import React from 'react';
import SectionTitle from '../../../components/section-title';
import { Link } from 'gatsby';
import Aluminium from '../../../content/home/accross-seven-key-verticals/aluminium';
import Power from '../../../content/home/accross-seven-key-verticals/power';
import Copper from '../../../content/home/accross-seven-key-verticals/copper';
import OilGas from '../../../content/home/accross-seven-key-verticals/oil-gas';
import Zinc from '../../../content/home/accross-seven-key-verticals/zinc';
import IronOreSteel from '../../../content/home/accross-seven-key-verticals/iron-ore-steel';
import ContentSlider from '../../../components/content-slider';
import ScrollPositionAnimation from '../../../components/scrollpositionanimation';

const OurBusinessScale = () => {
  const slider = {
    slides: [<Zinc/>,  <OilGas />, <Aluminium />, <Power />, <Copper />, <IronOreSteel/>],
  };

  const breakpoint = [
    {
      breakpoint: 1190,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: '150px',
        dots: true,
        arrows: false,
      },
    },
    {
      breakpoint: 640,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 2,
        centerMode: true,
        centerPadding: '80px',
        dots: true,
        arrows: false,
      },
    },
  ];
  return (
    <div className="our-business-scale">
      <div className="our-business-scal-inner">
        <div className="container">
          <div className="container-inner">
            <ScrollPositionAnimation targetElement1="anim-13">
              <SectionTitle lighttext="Our Business" boldtext="and Scale" isSectionH1={false}></SectionTitle>
              <div className="right-to-left anim-13">
                <div className="slider-section">
                  <ContentSlider
                    data={slider.slides}
                    slidesToShow={4}
                    slidesToScroll={4}
                    responsive={breakpoint}
                    customClass="blue-dots-slider"
                  />
                </div>
                <div className="button-bottom">
                  <Link to="/overview/vedanta-at-a-glance/business-verticals" className="solid-btn ">
                    Our Business Verticals
                  </Link>
                </div>
              </div>
            </ScrollPositionAnimation>
          </div>
        </div>
      </div>
      <div className="footer-banner"></div>
    </div>
  );
};

export default OurBusinessScale;
